import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { fundraisingService } from '../../services/fundraisingService';
import i18n from '@/i18n';

const { t } = i18n;

export const useCreateFundraisingApplication = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      fundraisingService.createApplication(payload).then(response => {
        const { status, data } = response;
        if (status === 201) {
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.application_list] });
          Notify.success({ text: t('fundraising:applications.application_created') });
          return data;
        }
      }),
  });
};
